<script type="ts">
	import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
	import { onMount } from 'svelte';

	// {"countryCode":"UY","national":"098 470 177","international":"+598 98 470 177","type":"mobile","validated":true}
	type PhoneNumber = {
		countryCode: string;
		national: string;
		international: string;
		type: string;
		validated: boolean;
	};

	export let value: PhoneNumber | string;
	export let placeholder = 'Teléfono';

	let formattedPhone: PhoneNumber;
	let inputPhone: string = '';

	const countries = [
		{
			code: 'UY',
			name: 'Uruguay',
			flag: 'https://flagcdn.com/uy.svg'
		},
		{
			code: 'AR',
			name: 'Argentina',
			flag: 'https://flagcdn.com/ar.svg'
		},
		{
			code: 'BR',
			name: 'Brasil',
			flag: 'https://flagcdn.com/br.svg'
		}
	];
	let selectedCountry = countries[0];

	function check() {
		// 	// console.log('check', value);
		const res = parsePhoneNumberFromString(inputPhone, selectedCountry.code.toString());
		formattedPhone = {
			countryCode: res?.countryCallingCode,
			national: res?.formatNational(),
			international: res?.formatInternational(),
			type: res?.getType() == 'FIXED_LINE' ? 'fixed_line' : 'MOBILE' ? 'mobile' : 'unknown',
			validated: res?.isValid()
		};

		value = formattedPhone;
	}

	function changeCountry(country) {
		console.log('changeCountry');
		selectedCountry = country;
		check();
	}

	onMount(() => {
		check();
	});
</script>

<div>
	<label for="phone" class="block text-sm font-medium text-gray-900 dark:text-gray-300"
		>{placeholder}</label
	>
	<div
		class="relative flex items-center w-full   border border-gray-200 rounded-lg focus:border-blue-300 invalid:border-red-500"
	>
		<div class=" relative inline-block text-left dropdown">
			<button
				class="inline-flex justify-center w-full px-4 py-2 text-sm font-medium leading-5 text-gray-700 transition duration-150 ease-in-out bg-white border-r border-gray-300  hover:text-gray-500 focus:outline-none  focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800"
				type="button"
				aria-haspopup="true"
				aria-expanded="true"
				aria-controls="headlessui-menu-items-117"
			>
				<div class="flex">
					<img src={selectedCountry.flag} width="30" alt={selectedCountry.name} />
					<p class="text-sm pl-2 leading-5 hidden md:block">{selectedCountry.name}</p>
				</div>
				<svg class="w-5 h-5 ml-2 -mr-1" viewBox="0 0 20 20" fill="currentColor"
					><path
						fill-rule="evenodd"
						d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
						clip-rule="evenodd"
					/></svg
				>
			</button>
			<div
				class="opacity-0 invisible dropdown-menu transition-all duration-300 transform origin-top-right -translate-y-2 scale-95"
			>
				<div
					class="absolute left-0 w-56 mt-2 origin-top-right bg-white border border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg outline-none z-50"
					aria-labelledby="headlessui-menu-button-1"
					id="headlessui-menu-items-117"
					role="menu"
				>
					{#each countries as country}
						<div class="px-4 py-3 flex" on:click={() => changeCountry(country)}>
							<img src={country.flag} width="24" alt={country.name} />
							<p class="text-sm pl-2 leading-5">{country.name}</p>
						</div>
					{/each}
				</div>
			</div>
		</div>

		<input
			type="text"
			class=" text-sm px-4 py-3 pr-12 flex-grow focus:border-none focus:outline-none bg-transparent"
			{placeholder}
			bind:value={inputPhone}
			on:keyup={() => check()}
		/>
	</div>
</div>

<style>
	.dropdown:focus-within .dropdown-menu {
		opacity: 1;
		transform: translate(0) scale(1);
		visibility: visible;
	}
</style>
